import { useState } from 'react';

import { useKimLhc } from '@/context/KimLhc';
import { useGetKimLhcResult } from '@/hooks/useGetKimLhcResult';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useSandboxExistsReport } from '@/hooks/useSandbox/useSandboxExistsReport';
import { SendReportModalProps, Report } from '@/components/ui/Modals/SendReportModal/types';

export function useResultData() {
	const { report_id, file_id, form } = useKimLhc();
	const { organization, company, isSandbox, sendReport } = useApplicationContext();
	const [isSendReportModalOpen, setIsSendReportModalOpen] = useState<boolean>(false);
	const [actionPlanModalOpen, setActionPlanModalOpen] = useState<boolean>(false);
	const [editingActionPlanId, setEditingActionPlanId] = useState<string | null>(null);

	const { isLoading, data, error } = useGetKimLhcResult({
		id: report_id!,
		company_id: company?.id!,
		organization_id: organization?.id!
	});

	const { data: existsData } = useSandboxExistsReport(
		{
			report_type: 'KIM_LHC',
			file_id: file_id ?? '',
			company_id: company?.id,
			organization_id: organization?.id
		},
		{
			enabled: Boolean(isSandbox && file_id && company?.id && organization?.id)
		}
	);

	function handleSendReport(): void {
		const payload = {
			report_type: 'KIM_LHC',
			file_id: file_id ?? '',
			company_id: company?.id,
			organization_id: organization?.id,
			id: report_id ?? ''
		};

		sendReport(payload, '/reporting');
		form.resetFields();
	}

	function handleCloseSendReportModal(): void {
		setIsSendReportModalOpen(false);
	}

	function handleOpenSendReportModal(): void {
		setIsSendReportModalOpen(true);
	}

	function handleOpenActionPlanModal(): void {
		setActionPlanModalOpen(true);
	}

	function handleCloseActionPlanModal(): void {
		setActionPlanModalOpen(false);
		setEditingActionPlanId(null);
	}

	function mountSendReportModalProps(): SendReportModalProps {
		const report: Report = {
			id: data?.id ?? '',
			workstation_name: data?.information.workstationName ?? '',
			tools_to_show: [],
			action_plans: [],
			files_names: [data?.information.fileName ?? '']
		};
		return {
			isOpen: isSendReportModalOpen,
			onCancel: handleCloseSendReportModal,
			onConfirm: handleSendReport,
			report: report,
			exists: existsData?.exists ?? false
		};
	}

	return {
		isLoading,
		data,
		error,
		isSandbox,
		handleSendReport,
		handleCloseSendReportModal,
		handleOpenSendReportModal,
		mountSendReportModalProps,
		actionPlanModalOpen,
		handleOpenActionPlanModal,
		handleCloseActionPlanModal,
		editingActionPlanId,
		setEditingActionPlanId
	};
}
